import React from 'react';
import './FaqDeleteModal.scss';
import ButtonNew from 'components/inputs/ButtonNew';
import MiniModal from 'components/MiniModal';

const FaqDeleteModal = ({ text, onConfirm, onCancel }) => {
  return (
    <MiniModal onExit={onCancel}>
      <div className="FaqDeleteModal">
        <div className="FaqDeleteModal-text-container">{text}</div>
        <div className="FaqDeleteModal-button-container">
          <ButtonNew
            label="Ok"
            buttonClasses="secondary-button-small"
            onClick={onConfirm}
          />
          <ButtonNew
            label="Cancel"
            buttonClasses="secondary-button-small"
            onClick={onCancel}
          />
        </div>
      </div>
    </MiniModal>
  );
};

export default FaqDeleteModal;
